import React from 'react';
import WidgetEmbedsSection from './WidgetEmbedsSection';

const WidgetsTab = () => {
  // Get organization ID from localStorage
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const organizationId = userData.organizationId || localStorage.getItem('organizationId');

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Booking Flows</h2>
        <p className="text-gray-600">
          Embed booking flows on your website to let customers book directly
        </p>
      </div>

      {organizationId ? (
        <WidgetEmbedsSection organizationId={organizationId} />
      ) : (
        <div className="text-center py-12 text-gray-500">
          Organization ID not found. Please refresh the page.
        </div>
      )}
    </div>
  );
};

export default WidgetsTab;
